import { QUESTIONNAIRE_STATUS } from '../../../../../constants';
import { DOCUMENT_TYPES } from '../../../../../pages/questionnaires/onboarding/constants';
import { INSURANCE_DOCUMENT_SUB_TYPES } from '../../../../../pages/questionnaires/onboarding/components/forms/insurance/constants';
import {
  FORTA_BLUE,
  FORTA_BROWN,
  FORTA_ORANGE,
  FORTA_PINK,
  FORTA_SUCCESS,
} from '../../../../../utils/colors';

import type { FAutocompleteOption } from '../../../../../components/baseV2';

export const QUESTIONNAIRE_TYPES = {
  INTAKE: 'intake',
  ONBOARDING: 'onboarding',
} as const;

export const QUESTIONNAIRE_OPTIONS = [
  {
    label: 'Onboarding Questionnaire',
    value: QUESTIONNAIRE_TYPES.ONBOARDING,
  },
  {
    label: 'Intake Questionnaire',
    value: QUESTIONNAIRE_TYPES.INTAKE,
  },
] as const;

export const QUESTIONNAIRE_TYPE_LABELS = {
  [QUESTIONNAIRE_TYPES.ONBOARDING]: 'Onboarding',
  [QUESTIONNAIRE_TYPES.INTAKE]: 'Intake',
} as const;

export const QUESTIONNAIRE_STATUS_LABELS = {
  [QUESTIONNAIRE_STATUS.STARTED]: 'Started',
  [QUESTIONNAIRE_STATUS.IN_PROGRESS]: 'In progress',
  [QUESTIONNAIRE_STATUS.COMPLETED]: 'Completed',
} as const;

export const QUESTIONNAIRE_TYPE_COLORS = {
  [QUESTIONNAIRE_TYPE_LABELS[QUESTIONNAIRE_TYPES.ONBOARDING]]: FORTA_BROWN,
  [QUESTIONNAIRE_TYPE_LABELS[QUESTIONNAIRE_TYPES.INTAKE]]: FORTA_PINK,
} as const;

export const QUESTIONNAIRE_STATUS_COLORS = {
  [QUESTIONNAIRE_STATUS_LABELS[QUESTIONNAIRE_STATUS.STARTED]]: FORTA_ORANGE,
  [QUESTIONNAIRE_STATUS_LABELS[QUESTIONNAIRE_STATUS.IN_PROGRESS]]: FORTA_BLUE.light1,
  [QUESTIONNAIRE_STATUS_LABELS[QUESTIONNAIRE_STATUS.COMPLETED]]: FORTA_SUCCESS,
} as const;

export const QUESTIONNAIRE_CHIP_WIDTH = 110;
export const QUESTIONNAIRE_CHIP_FONT_SIZE = 14;

export const COMPLETED_QUESTIONNAIRE_DOCUMENT_MUTATION_MESSAGE =
  'Documents cannot be uploaded or deleted for a completed questionnaire';

export const COMPLETED_QUESTIONNAIRE_DOCUMENT_TOAST_ID =
  'completed-questionnaire-document-mutation';

export const QUESTIONNAIRE_TABLE_OPTIONS = {
  filter: false,
  print: false,
  search: false,
  viewColumns: false,
  pagination: true,
  download: false,
  sort: true,
  selectableRows: 'none',
  responsive: 'standard',
  textLabels: {
    body: {
      noMatch: 'No questionnaires found',
    },
  },
} as const;

export const DOCUMENT_TYPE_OPTIONS: ReadonlyArray<FAutocompleteOption> = [
  { value: DOCUMENT_TYPES.INSURANCE_CARD, label: 'Insurance Card' },
  { value: DOCUMENT_TYPES.REFERRAL_REPORT, label: 'Referral Report' },
];

export const DOCUMENT_SUB_TYPE_OPTIONS: ReadonlyArray<FAutocompleteOption> = [
  { value: INSURANCE_DOCUMENT_SUB_TYPES.PRIMARY_FRONT, label: 'Primary Front' },
  { value: INSURANCE_DOCUMENT_SUB_TYPES.PRIMARY_BACK, label: 'Primary Back' },
  { value: INSURANCE_DOCUMENT_SUB_TYPES.SECONDARY_FRONT, label: 'Secondary Front' },
  { value: INSURANCE_DOCUMENT_SUB_TYPES.SECONDARY_BACK, label: 'Secondary Back' },
];

// Client-side gate only — visible in the JS bundle. Not a server secret.
export const DELETE_ONBOARDING_DOCUMENT_PASSWORD = 'vR8#mKq2!XnP7wLz';
